export default {
  name: 'accountStatus'
}
